<template>
  <ul class="mb-5 nav nav--wizard d-flex justify-content-center">
    <li
      v-for="(route, index) in routes"
      :key="route.path"
      :class="['nav-item', getColorItem(`${route.path}`)]"
    >
      <router-link
        :to="`${route.path}`"
        :content="index + 1"
        aria-current="page"
        :class="['nav-link', getColorItem(`${route.path}`)]"
      >
        {{ route.name }}
      </router-link>
    </li>
  </ul>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import { mapState } from 'pinia'
  import {
    useRouteBirdId,
    RoutesType,
  } from '@/store/Pinia/useRouteBirdId.store'

  export default defineComponent({
    name: 'NavWizzard',
    props: {
      currentPage: {
        type: String,
        default: '/',
      },
    },
    data: () => ({
      routes: [] as { [key: string]: any }[],
    }),
    computed: {
      ...mapState(useRouteBirdId, ['getRoutesDone']),
    },
    mounted() {
      const { options } = this.$router
      const birdIdRoutes = options.routes.find(
        (value) => value.path === '/birdId',
      )
      const formatted = birdIdRoutes?.children || []
      this.routes = formatted.filter((value) => value.name !== 'checkinfo')
    },
    methods: {
      getColorItem(route: string | keyof RoutesType) {
        if (route === this.currentPage) {
          return 'active'
        }
        if (this.getRoutesDone[route] || this.currentPage === 'alldone') {
          return 'disabled nav--wizard__nav-item--success'
        }
        return ''
      },
    },
  })
</script>

<style lang="stylus">

  @media screen and (max-width: 768px)
    .nav--wizard
      flex-direction: column
      text-align: left
      margin-left: 1rem !important
      margin-bottom: 1rem !important
    .nav-link
      content: ''
      &:after
        display: none
       content: ''
</style>
